"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleContactPicker = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../i18n/i18n");
var _useTheme = require("../../theme/utils/useTheme");
var _selectV = require("../selectV2");
var _contactPickerTheme = require("./contactPickerTheme");
var _ContactPickerCatalog = require("./i18n/ContactPickerCatalog");
var _getFilterOption = require("./utils/getFilterOption");
var _getOptionKey = require("./utils/getOptionKey");
var _getSelectedValueAvatar = require("./utils/getSelectedValueAvatar");
var _optionFormatter = require("./utils/optionFormatter");
var _optionToString = require("./utils/optionToString");
var _singleSelectedValueFormatter = require("./utils/singleSelectedValueFormatter");
const warnLackOfControl = (0, _lodestarUtils.warnOnce)("SingleContactPicker: To control the text input within the contact picker control, both the setInputValue and inputValue props must be defined");
const SingleContactPickerBase = _ref => {
  let {
    className,
    clientId,
    onChange,
    options,
    selectedOption,
    getOptionKey = _getOptionKey.getOptionKey,
    optionToString = _optionToString.optionToString,
    filterOption: providedFilterOption,
    formatOption: providedFormatOption,
    onViewMembers,
    optionHeight,
    locale,
    formatSelectedValue: providedFormatSelectedValue,
    placeholder: providedPlaceholder,
    portalProps,
    menuIsOpen: providedMenuIsOpen,
    inputValue: providedInputValue,
    requireInput = true,
    setInputValue: providedSetInputValue,
    innerRef,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    i18n
  } = (0, _i18n.useI18n)();

  // We need to warn consumers if they try to halfway control the input
  if (process.env.NODE_ENV !== "production") {
    if (providedInputValue !== undefined && !providedSetInputValue || providedSetInputValue !== undefined && providedInputValue == null) {
      warnLackOfControl();
    }
  }
  const localRef = (0, _react.useRef)(null);
  const combinedRef = (0, _lodestarUtils.useForkRef)(localRef, innerRef || null);

  // Let's control the input value to cover menu state
  const [internalInputValue, internalSetInputValue] = (0, _react.useState)("");
  const setInputValue = value => {
    internalSetInputValue(value);
    providedSetInputValue && providedSetInputValue(value);
  };
  (0, _react.useEffect)(() => {
    if (providedInputValue !== undefined && providedInputValue !== internalInputValue) {
      internalSetInputValue(providedInputValue);
    }
  }, [providedInputValue, internalInputValue]);
  function optionFormatter(option, index, highlightedIndex, optionSpreadProps) {
    const renderedOption = (0, _optionFormatter.optionFormatter)(option, "single", index, highlightedIndex, optionSpreadProps, option.id === selectedOption?.id, internalInputValue, portalProps, optionToString, onViewMembers);
    return renderedOption;
  }
  const focusRoot = (0, _react.useCallback)(() => localRef.current?.focus(), []);
  const valueFormatter = _ref2 => {
    let {
      option
    } = _ref2;
    return option ? (0, _singleSelectedValueFormatter.singleSelectedValueFormatter)(option, onViewMembers, focusRoot) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  };
  return /*#__PURE__*/_react.default.createElement(_selectV.SelectV2, (0, _extends2.default)({
    className: className,
    clientId: clientId,
    onChange: onChange,
    options: options,
    formatOption: providedFormatOption ? providedFormatOption : optionFormatter,
    formatSelectedValue: providedFormatSelectedValue ? providedFormatSelectedValue : valueFormatter
    // Include this here since we need it until a major release can remove it.
    ,
    tempFormatSelectedValueWrapperFix: true,
    optionHeight: optionHeight || _contactPickerTheme.contactPickerTheme.option.overallHeight(themeMode),
    optionToString: optionToString,
    selectedOption: selectedOption,
    contentBefore: (0, _getSelectedValueAvatar.getSelectedValueAvatar)(selectedOption, themeMode),
    getOptionKey: getOptionKey,
    locale: locale,
    isSearchable: true,
    hideDropdownArrow: requireInput,
    filterOption: providedFilterOption ? providedFilterOption : (0, _getFilterOption.getFilterOption)(rest.useFuzzySearch),
    menuIsOpen: providedMenuIsOpen !== undefined ? providedMenuIsOpen : requireInput ? internalInputValue.trim().length > 0 :
    // Set to undefined to release control to the SelectV2.
    undefined,
    inputValue: internalInputValue,
    setInputValue: setInputValue,
    placeholder: providedPlaceholder || i18n._( /*i18n*/{
      id: "Type to search",
      comment: "Placeholder text for a contact picker when the user has not entered any search text yet."
    }),
    portalProps: portalProps,
    innerRef: combinedRef
  }, rest));
};
SingleContactPickerBase.displayName = "SingleContactPickerBase";
const SingleContactPicker = _ref3 => {
  let {
    ...props
  } = _ref3;
  (0, _ContactPickerCatalog.injectCatalog)();
  return /*#__PURE__*/_react.default.createElement(_i18n.I18nContextProvider, {
    locale: props.locale
  }, /*#__PURE__*/_react.default.createElement(SingleContactPickerBase, props));
};
exports.SingleContactPicker = SingleContactPicker;
SingleContactPicker.displayName = "SingleContactPicker";
//# sourceMappingURL=SingleContactPicker.js.map